export const ENDPOINTS = [
    {
        info: 'local',
        text: 'Local Node (Own, 127.0.0.1:9944)',
        value: 'ws://127.0.0.1:9944/'
    }
];
export const ENDPOINT_DEFAULT = ENDPOINTS[0];
